import Vue from 'vue'
import Vuex from 'vuex'
import { client, getTokenPayload } from '@/resources'
import UserResource from '@/resources/user'

export { mapGetters } from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        instance: 'http://localhost:8080',
        token: localStorage.getItem('token') || null,
        userResource: null,
        companyResources: null,
        permissions: null,
        clearNav: true,
        clearNavMaxScrollY: 10,
        apiMeta: null,
        pageTitle: 'Node.js Jobs',
        wrapperClasses: [],
        showMessagesSidebar: false,
        composeMessageToUserResource: null
    },
    getters: {
        token(state) {
            return state.token
        },
        userId(state) {
            let payload = getTokenPayload(state.token)
            if (payload) {
                return payload['user_id']
            }
            return undefined
        },
        userResource(state) {
            return state.userResource
        },
        permissions(state) {
            return state.permissions
        },
        isSuperuser(state) {
            if (state.permissions && !!state.permissions['is_superuser']) {
                return true
            }

            return false
        },
        navIsClear(state) {
            return state.clearNav
        },
        clearNavMaxScrollY(state) {
            return state.clearNavMaxScrollY
        },
        pageTitle(state) {
            return state.pageTitle
        },
        wrapperClasses(state) {
            return state.wrapperClasses
        },
        showMessagesSidebar(state) {
            return state.showMessagesSidebar
        },
        composingMessageTo(state) {
            return state.composeMessageToUserResource
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        setUserResource(state, userResource) {
            state.userResource = userResource
        },
        setPermissions(state, permissionsObj) {
            state.permissions = permissionsObj
        },
        setCompanyResources(state, companyResources) {
            state.companyResources = companyResources
        },
        setNavClear(state, clearOpts) {
            state.clearNav = clearOpts.isClear
            state.clearNavMaxScrollY = clearOpts.maxScrollY || 10
        },
        setWrapperClasses(state, wrapperClasses) {
            state.wrapperClasses = wrapperClasses
        },
        setPageTitle(state, title) {
            let docTitle = title ? `${title} | Node.js Jobs` : 'Node.js Jobs'
            state.pageTitle = docTitle
            document.title = docTitle
        },
        setAPIMeta(state, metaObj) {
            state.apiMeta = metaObj
        },
        logout(state) {
            localStorage.clear()
            state.userResource = null
            state.token = null
        },
        showMessagesSidebar(state) {
            state.showMessagesSidebar = true
        },
        hideMessagesSidebar(state) {
            state.showMessagesSidebar = false
        },
        toggleMessagesSidebar(state) {
            state.showMessagesSidebar = !state.showMessagesSidebar
        },
        composeMessage(state, userResource) {
            state.composeMessageToUserResource = userResource
        }
    },
    actions: {
        async login(context, creds) {
            let result = await UserResource.login(creds.username, creds.password)

            context.commit('setToken', result.token)
            context.commit('setUserResource', result.userResource)
            await context.dispatch('getUserPermissions')
            return result
        },
        async getUserResource(context) {
            if (context.state.userResource) {
                // User has already been retrieved
                return await Promise.resolve(context.state.userResource)
            }
            // Get User
            let user = await UserResource.detail(context.getters.userId)
            // Get User's companies too
            context.commit('setUserResource', user)
            return user
        },
        async getUserPermissions(context) {
            if (context.state.permissions) {
                return await Promise.resolve(context.state.permissions)
            }
            let user = await context.dispatch('getUserResource')
            let perms = await user.getPermissions()
            context.commit('setPermissions', perms)
            return perms
        },
        async getUserCompanies(context) {
            if(context.state.companyResources !== null) {
                return await Promise.resolve(context.state.companyResources)
            }
            let user = await context.dispatch('getUserResource')
            let companies = await user.getCompanies()
            context.commit('setCompanyResources', companies)
            return companies
        },
        async getAPIMeta(context) {
            if(context.state.apiMeta) {
                return await Promise.resolve(context.state.apiMeta)
            }
            
            let apiMetaRequest = await client.get('/')
            context.commit('setAPIMeta', apiMetaRequest.data)
            return apiMetaRequest.data
        }
    },
    modules: {},
})
